#import "../fragments/enrollment-form-fragment.graphql"

query GetInboxEnrollmentForm {
    inboxEnrollmentForm {
        ...EnrollmentFormFragment
    }
}
